import { render } from "./DragZone.vue?vue&type=template&id=43621c3c"
import script from "./DragZone.vue?vue&type=script&lang=ts"
export * from "./DragZone.vue?vue&type=script&lang=ts"
script.render = render

export default script